import React from 'react';
import {FormattedMessage} from "react-intl";

import FormikInput from "components/input/new/FormikInput";

import {greyishBlue500} from "assets/jss/main";

// The label the customer reads on the eshop; the name stays the Marketplace's own (WMS, back-office).
function CheckoutNameField(props) {
    return (
        <>
            <FormikInput
                name={'checkoutName'}
                label={'shippingMethods.form.field.checkoutName.label'}
                placeholder={'shippingMethods.form.field.checkoutName.placeholder'}
            />
            <span style={{fontSize: '12px', color: greyishBlue500}}>
                <FormattedMessage id={'shippingMethods.form.field.checkoutName.help'}/>
            </span>
        </>
    );
}

export default CheckoutNameField;
